export default "__VITE_ASSET__CQ1VovqT__"